import { render } from "./EscrowPagos.vue?vue&type=template&id=fc2e8d5c"
import script from "./EscrowPagos.vue?vue&type=script&lang=js"
export * from "./EscrowPagos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__